import React from 'react';
import {
    required,
} from 'react-admin'
import SelectPhyQuest from '../controls/SelectPhyQuest'

const YesNoExt = [
    {
        id: 'Y',
        name: 'Yes'
    },
    {
        id : 'N',
        name: 'No'
    },
    {
        id : '/',
        name: 'N/A'
    }
  ]

  const YesNo = [
    {
        id: 'Y',
        name: 'Yes'
    },
    {
        id : 'N',
        name: 'No'
    }
  ]


const Questionnaire=()=>{

    return(
        <div>
                <table style={{width: '100%'}}>
                    <tbody>
                    <tr >
                            <td colSpan="2"  bgcolor="silver" height="35">&nbsp;&nbsp;<b>Are you</b></td>
                        </tr>
                        <tr> 
                            <SelectPhyQuest label = '1.	Feeling healthy and well today? ' id='f_healthy' field='f_healthy' targetvalue='Y'  choices={YesNo}  validate={required()} />
                        </tr>
                        <tr  id= 'hq_2' > 
                            <SelectPhyQuest label = '2.	Currently taking an antibiotic or other medication for an infection?' id='f_antibiotic' field='f_antibiotic' targetvalue='N'  choices={YesNo}  />      
                            
                        </tr >
                        <tr id= 'hq_3' >
                            <SelectPhyQuest label = '3.	Currently taking any other medications?' id='f_other_med' field='f_other_med' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr  id= 'hq_4' >
                            <td  colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;<b>Please read the medication list.</b></td>
                        </tr>
                        <tr id= 'hq_5' >
                            <SelectPhyQuest label = '4.	Have you taken any medications on the medication list in the time frames indicated?' id='f_taken_med' field='f_taken_med' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_6' >
                                <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;<b>Please review the Risk Poster</b></td>
                            </tr>
                        <tr id= 'hq_6' > 
                            <SelectPhyQuest label = '5.	Did you review the Risk Poster?' id='f_risk' field='f_risk' targetvalue='Y'  choices={YesNo}  />
                        </tr>
                        <tr  id= 'hq_7' > 
                             <SelectPhyQuest label = '6.	Do you have any questions about anything mentioned on the Risk Poster?' id='f_quest_med' field='f_quest_med' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_8' >
                            <td colSpan="2" bgcolor="silver" height="35">In the past <b>two months, have you </b></td>
                        </tr>
                        <tr id= 'hq_9' > 
                            <SelectPhyQuest label = '7.	Had any vaccinations or other shots?' id='f_vaccination' field='f_vaccination' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_10'  > 
                            <SelectPhyQuest label = '8.	Had contact with someone who was vaccinated for smallpox in the past 8 weeks?' id='f_smallpox' field='f_smallpox' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_11' > 
                            <SelectPhyQuest label = '9. Donated whole blood, platelets or plasma at another center?' id='f_another_center' field='f_another_center' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_12' >
                                <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;In the past <b>three months</b>, have you</td>
                            </tr>
                        <tr id= 'hq_13' > 
                            <SelectPhyQuest label = '10.	Had a blood transfusion or received other blood products?' id='f_transfusion' field='f_transfusion' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_14' > 
                            <SelectPhyQuest label = "11.	Come into contact with someone else's blood?" id='f_contact_blood' field='f_contact_blood' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_15' > 
                            <SelectPhyQuest label = '12. Had an accidental needle-stick involving exposure to blood?' id='f_needle' field='f_needle' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_16'> 
                            <SelectPhyQuest label = '13.	Had sexual contact with anyone who has ever had HIV or has ever had a positive test for HIV virus?' id='f_sex_contact_hiv' field='f_sex_contact_hiv' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_17'> 
                            <SelectPhyQuest label = '14.	Received money, drugs, or other payment for sex?' id='f_money_sex' field='f_money_sex' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_18'> 
                            <SelectPhyQuest label = '15. Had sexual contact with a prostitute or anyone else who takes money or drugs or other payment for sex?' id='f_sex_contact_pay' field='f_sex_contact_pay' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_19'> 
                            <SelectPhyQuest label = '16.	Used needles to take drugs, steroids, or anything not prescribed by your doctor?' id='f_used_needle' field='f_used_needle' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_20' > 
                            <SelectPhyQuest label = '17. Had sexual contact with anyone who has ever used needles to take drugs or steroids, or anything not prescribed by their doctor?' id='f_sex_contact_used_needle' field='f_sex_contact_used_needle' targetvalue='N'  choices={YesNo}  />                          
                        </tr>
                        <tr id= 'hq_21'> 
                            <SelectPhyQuest label = '18.	Female Donors: Had sexual contact with a male who had sexual contact with another male in the past 3 months?' id='f_female_male_male' field='f_female_male_male' targetvalue='N'  choices={YesNoExt}  altvalue='/' />
                        </tr>
                        <tr id= 'hq_22'> 
                            <SelectPhyQuest label = '19.	Gotten a tattoo or had one touched-up?' id='f_tattoo' field='f_tattoo' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_23'> 
                            <SelectPhyQuest label = '20.	Had an ear or body piercing?' id='f_piercing' field='f_piercing' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_24' > 
                            <SelectPhyQuest label = '21.	Had or been treated for syphilis or gonorrhea?' id='f_syphillis' field='f_syphillis' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_25' >
                            <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;In the past <b>four months</b>, have you</td>
                        </tr>
                        <tr id= 'hq_26'> 
                            <SelectPhyQuest label = '22. Donated a double unit of red blood cells using an apheresis machine?' id='f_double_unit' field='f_double_unit' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_27'> 
                            <SelectPhyQuest label = '23. Had surgery or a diagnostic, medical or dental procedure?' id='f_surgery' field='f_surgery' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_28'> 
                            <SelectPhyQuest label = '24. Had acupuncture?' id='f_acupuncture' field='f_acupuncture' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_29' >
                            <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;In the past <b>six months</b>, have you</td>
                        </tr>
                        <tr id= 'hq_30'> 
                            <SelectPhyQuest label = '25. Female Donors: been pregnant or are you pregnant now?' id='f_pregnant' field='f_pregnant' targetvalue='N'  choices={YesNoExt} altvalue='/' />
                            
                        </tr>
                        <tr id= 'hq_31' >
                            <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;In the past <b>12 months</b>, have you</td>
                        </tr>
                        <tr id= 'hq_32'> 
                            <SelectPhyQuest label = '26. Received during surgery bone, tissue or skin?' id='f_received_tissue' field='f_received_tissue' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_33'> 
                            <SelectPhyQuest label = '27.	Had sexual contact with a person who has hepatitis?' id='f_sex_hep' field='f_sex_hep' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_34'> 
                            <SelectPhyQuest label = '28.	Been in juvenile detention, lockup, jail, or prison for 72 hours or more consecutively?' id='f_jail' field='f_jail' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_35' >
                            <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;From <b>1980 through 1996</b>, did you</td>
                        </tr>
                        <tr id= 'hq_36'> 
                            <SelectPhyQuest label = '29.	Spend time that adds up to 3 months or more in England, Northern Ireland, Scotland, Wales, the Isles of Man, the Channel Islands, Gibraltar, or the Falkland Islands?' id='f_uk' field='f_uk' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_37' >
                            <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;From <b>1980 through 2001</b>, did you</td>
                        </tr>
                        <tr id= 'hq_38'> 
                            <SelectPhyQuest label = '30.	Spend time that adds up to 5 years or more in France or Ireland? Time spent in Ireland does not include time spent in Northern Ireland which is part of the United Kingdom?' id='f_france' field='f_france' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_39' >
                            <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;From <b>1980 through the present</b>, did you</td>
                        </tr>
                        <tr id= 'hq_40'> 
                            <SelectPhyQuest label = '31.	Receive a blood transfusion in France, Ireland, England, Northern Ireland, Scotland, Wales, the Isle of Man, the Channel Islands, Gibraltar, or the Falkland Islands?' id='f_blood_uk' field='f_blood_uk' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_41' >
                            <td colSpan="2" bgcolor="silver" height="35">&nbsp;&nbsp;Have you <b>EVER</b></td>
                        </tr>
                        <tr id= 'hq_42'> 
                            <SelectPhyQuest label = '32.	Had a positive test for HIV?' id='f_had_hiv' field='f_had_hiv' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_43'> 
                            <SelectPhyQuest label = '33.	Had a transplant such as an organ or bone marrow?' id='f_had_transplant' field='f_had_transplant' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_44'> 
                            <SelectPhyQuest label = '34.	Received a dura mater (or brain covering) graft?' id='f_graft' field='f_graft' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_45'> 
                            <SelectPhyQuest label = '35.	Had any type of cancer, including leukemia?' id='f_had_cancer' field='f_had_cancer' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_46'> 
                            <SelectPhyQuest label = '36.	Had any problem with your heart or lungs?' id='f_prob_heart' field='f_prob_heart' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_47'> 
                            <SelectPhyQuest label = '37.	Had any problem with your liver or kidneys?' id='f_prob_liver' field='f_prob_liver' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_48'> 
                            <SelectPhyQuest label = '38. Had a bleeding condition or a blood disease?' id='f_had_bleeding' field='f_had_bleeding' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_49'> 
                            <SelectPhyQuest label = '39.	Had a transplant or other medical procedure that involved being exposed to live cells, tissues or organs from an animal (xenotransplant)?' id='f_animal' field='f_animal' targetvalue='N'  choices={YesNo}  />
                           
                        </tr>
                        <tr id= 'hq_50'> 
                            <SelectPhyQuest label = '40. Male Donors: Have you ever had sexual contact with another male?' id='f_sex_male_male' field='f_sex_male_male' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_51'> 
                            <SelectPhyQuest label = '41. Have you ever had any type of nervous system disease?' id='f_nervous' field='f_nervous' targetvalue='N'  choices={YesNo}  />
                           
                        </tr>
                        <tr id= 'hq_52'> 
                            <SelectPhyQuest label = '42. Have you ever had a history of recurrent episodes of fainting?' id='f_fainting' field='f_fainting' targetvalue='N'  choices={YesNo}  />
                           
                        </tr>
                        <tr id= 'hq_53'> 
                            <SelectPhyQuest label = '43. Have you ever had a history of seizures or convulsions?' id='f_seizures' field='f_seizures' targetvalue='N'  choices={YesNo}  />
                           
                        </tr>
                        <tr id= 'hq_54'> 
                            <SelectPhyQuest label = '44. Have you ever been diagnosed with diabetes?' id='f_diabetes' field='f_diabetes' targetvalue='N'  choices={YesNo}  />
                            
                        </tr>
                        <tr id= 'hq_55'> 
                            <SelectPhyQuest label = '45. Have you ever been diagnosed with any other serious active, chronic, or relapsing disease?' id='f_chronic' field='f_chronic' targetvalue='N'  choices={YesNo}  />
                        </tr>
                        <tr id= 'hq_56'> 
                            <SelectPhyQuest label = '46. Have any of your relatives had Creutzfeld-Jakob disease?' id='f_relative' field='f_relative' targetvalue='N'  choices={YesNo}  />
                        </tr>
                    </tbody>
                </table>
                
        </div>

    )

}

export default Questionnaire;